module.exports = (__webpack_require__(/*! dll-reference dll_b58bab4c81fc7aefb34e */ "dll-reference dll_b58bab4c81fc7aefb34e"))("./node_modules/react/index.js");